import React from "react";
import { useTranslation } from "react-i18next";

const NotFound = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <h1 style={{ textAlign: "center", marginTop: "100px" }}>{t("404, Strony nie znaleziono")}</h1>
    </React.Fragment>
  );
};

export default NotFound;
